import React from 'react'
import styles from './status-finished.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import StatusColor from '../shared/status-color/status-color'
import RefreshIcon from 'react-icons/lib/fa/refresh'
import UnlinkIcon from 'react-icons/lib/fa/chain-broken'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const StatusFinished = ({
  classes,
  id,
  statusColor,
  mis,
  lastSync,
  usingGroupCall,
  onDisconnect,
  onPull
}) => (
  <>
    <div className={classes.container}>
      <StatusColor color={statusColor} />
      <div>
        <h5 className={classes.title}>
          Connected to {mis || 'MIS'} with{' '}
          {usingGroupCall ? 'GroupCall' : 'Wonde'}
        </h5>
        <p className={classes.content}>
          Last sync on {lastSync || ''}
          <Button icon={<RefreshIcon />} secondary action={() => onPull(id)}>
            Refresh
          </Button>
          {!usingGroupCall && (
            <Button
              icon={<UnlinkIcon />}
              secondary
              action={() =>
                openConfirmationDialog({
                  bodyText: `Are you sure that you want to break the link between Pobble and your MIS? You will have to manage data in Pobble manually from this point.`,
                  confirmText: 'Yes, break the link',
                  action: () => onDisconnect(id)
                })
              }>
              Unlink
            </Button>
          )}
        </p>
      </div>
    </div>
  </>
)

export default injectSheet(styles)(StatusFinished)
